import { render, staticRenderFns } from "./ReferralUsersReport.vue?vue&type=template&id=083c3048"
import script from "./ReferralUsersReport.vue?vue&type=script&lang=js"
export * from "./ReferralUsersReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports